import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "../../lib/api";
import { parseMedia } from "../../lib/media";
import MediaItem from "../MediaItem";

const GalleryPreview = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/gallery").then((r) => setItems(r.data.slice(0, 6))).catch(() => {});
  }, []);

  return (
    <section id="gallery" className="py-16 sm:py-24 bg-white" data-testid="gallery-preview-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-10">
          <div>
            <span className="text-brand-blue font-heading font-bold tracking-wider uppercase text-xs">Gallery</span>
            <h2 className="font-heading text-3xl sm:text-4xl font-bold mt-2">Moments from our school</h2>
            <p className="mt-2 text-sm text-[color:var(--text-secondary)]">Photos, Facebook reels and YouTube videos — all in one place.</p>
          </div>
          <Link to="/gallery" className="btn-ghost self-start sm:self-end" data-testid="gallery-view-all">
            View full gallery <ArrowRight size={16} />
          </Link>
        </div>

        {items.length === 0 ? (
          <p className="text-center text-[color:var(--text-secondary)]">Photos coming soon.</p>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6">
            {items.map((g, i) => {
              const m = parseMedia(g.image_url);
              const isFeatured = i === 0 && m.type === "image";
              const wrapperCls = isFeatured ? "md:col-span-2 md:row-span-2 rounded-[2rem]" : "rounded-[1.5rem]";
              const aspect = isFeatured
                ? "aspect-square md:aspect-auto md:h-full md:min-h-[420px]"
                : m.type === "facebook" && m.aspect === "9/16" ? "aspect-[9/16]"
                : m.type === "youtube" ? "aspect-video"
                : "aspect-square";
              return (
                <div key={g.id} className={`overflow-hidden ${wrapperCls} bg-cream`} data-testid={`gallery-preview-item-${i}`}>
                  <MediaItem url={g.image_url} caption={g.caption} aspectClassName={aspect} eager={isFeatured} testId={`gallery-preview-media-${i}`} cacheBust={g.created_at} />
                </div>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};

export default GalleryPreview;
